import Controler from "../common/control";
import React, { useEffect, useState } from "react";
import { Formik,Form} from "formik";
import { connect } from "react-redux";
import {getSchoolFormData, postSchoolIdp, clearSchoolIdpResponse} from '../../../store/slices/school/index'
import "../../assets/css/idp-medical.css";
import { fetchUser } from "../../../store/slices/user/index";
import Loader from "../common/loader";
import ButtonLoader from "../common/buttonLoader";
import ThankYou from "../common/thankYou";

const randomNum = ()=>{
  const d = new Date();
  const ms = d.getMilliseconds();
  return ms 
}
const IdpCollegeForms = (props) => {
    const [educationStream, setEducationStream] = useState(null)
    // const [studyInterestedData, setStudyInterestedData] = useState(null)
    const [fieldOfStudyData, setFieldOfStudyData] = useState(null)
    const [coursesData, setCoursesData] = useState(null)
    const [careersData, setCareersData] = useState(null)
    const [examsData, setExamsData] = useState(null)
    const [coachingMode, setCoachingMode] = useState(null)
    const [coachingLocation, setCoachingLocation] = useState(null)
    const [coachingInterestedData, setCoachingInterestedData] = useState(null)
    const [coachingData, setCoachingData] = useState(null)
    const [privateCollegeData, setPrivateCollegeData] = useState(null)
    const [scholarshipData, setScholarshipData] = useState(null)
    const [studyAbroadData, setStudyAbroadData] = useState(null)
    const [premiumGuidenceData, setPremiumGuidenceData] = useState(null)
    const [careersCounsellorData, setCareersCounsellorData] = useState(null)

    const [interestedField, setInterestedField] = useState('')
    const [destination, setDestination] = useState(null)
    const [checkEntity,setCheckEntity] = useState('')
    const [isLoading,setIsLoading] = useState(true)
    const [isDisable,setIsDisable] = useState(true)
    const [formikState, setFormikState] = useState({})
    const [isSubmitted,setIsSubmitted] = useState(false)
    const [submitLoader,setSubmitLoader] = useState(false)
    const [formikVal,setFormikVal] = useState({})
    const [count, setCount] = useState({num:7,show:true})

    useEffect(() => { 
      props.dispatch(fetchUser())
    }, [])

    useEffect(() => { 
      if(props.user?.data){
        props.dispatch(getSchoolFormData({uid: props.user?.data?.id, ms:randomNum()}));
      }
      let desti
      if(!!window.location?.search){
        desti = window.location?.search?.replace("?destination=", "");
      } else {
        desti = 'https://www.careers360.com'
      }
      setDestination(desti);
    }, [props.user?.data]);
    
    useEffect(() => { 
      if(props.idpPostData){
        if(['exam','field_of_study','field_of_study_interested', 'courses','careers','coaching_mode','coaching_location'].includes(checkEntity)){
          props.dispatch(getSchoolFormData({uid: props.user?.data?.id, ms:randomNum()}));
        }
      }
    }, [props.idpPostData]);

    const setFormikValue = (arr,type, stateName)=>{
      let checkedValue = []
      let item
      if(!!arr.value?.length){
        stateName(arr)
        for(item of arr.value){
          if(item.selected) {
            if(['exam','coaching','private_college','scholarship','premimum_guidence','courses','field_of_study','careers','coaching_location'].includes(type)){
              checkedValue.push(`${item.id}`)
            } else {
              checkedValue = `${item.id}`
            }
          }
        }
        setFormikState(prev => ({
          ...prev,
          [type]: checkedValue
        }))
      }
    }
    
    useEffect(()=>{
      if(!!props.idpData?.idp?.length){
        setIsLoading(false)
        setFieldOfStudyData(null)
        setCoursesData(null)
        // setStudyInterestedData(null)
        setCareersData(null)
        setExamsData(null)
        setCoachingData(null)
        setPrivateCollegeData(null)
        setCoachingInterestedData(null)
        setScholarshipData(null)
        setStudyAbroadData(null)
        setPremiumGuidenceData(null)
        setCareersCounsellorData(null)
        setCoachingMode(null)
        setCoachingLocation(null)
        let data
        setFormikState({})
        setEducationStream(props.idpData?.education_stream)
        for(data of props.idpData?.idp){
            if(data.entity === "field_of_study") {
              setFormikValue(data, 'field_of_study', setFieldOfStudyData)
              let interestedField = data?.value?.find(item => item.selected)
              setInterestedField(interestedField?.name)
            }
            else if(data.entity === "courses") setFormikValue(data, 'courses', setCoursesData)
            // else if(data.entity === "field_of_study_interested") setFormikValue(data, 'field_of_study_interested', setStudyInterestedData)
            else if(data.entity === "careers") {setFormikValue(data, 'careers', setCareersData)}
            else if(data.entity === "exam") {
              if(!!data?.value?.length) setFormikValue(data, 'exam', setExamsData)
            }
            else if(data.entity === "coaching_mode") setFormikValue(data, 'coaching_mode', setCoachingMode)
            else if(data.entity === "coaching_location") setFormikValue(data, 'coaching_location', setCoachingLocation)
            
            else if(data.entity === "coaching_interested") setFormikValue(data, 'coaching_interested', setCoachingInterestedData)
            else if(data.entity === "coaching") {
              if(!!data?.value?.length) setFormikValue(data, 'coaching', setCoachingData)
            }
            else if(data.entity === "private_college") setFormikValue(data, 'private_college', setPrivateCollegeData)
            else if(data.entity === "scholarship") setFormikValue(data, 'scholarship', setScholarshipData)
            else if(data.entity === "study_abroad_interested") setFormikValue(data, 'study_abroad_interested', setStudyAbroadData)
            else if(data.entity === "premimum_guidence") setFormikValue(data, 'premimum_guidence', setPremiumGuidenceData)
            else if(data.entity === "c360_counsellor_interested") setFormikValue(data, 'c360_counsellor_interested', setCareersCounsellorData)
        }
      }

      setTimeout(()=>{
        //if(props?.idpData?.idp_form_id != -1) window.location.search?.includes('destination=http') ? window.location.href = destination : window.location.href = 'https://www.careers360.com';

      },1000)
      
      if(props?.idpData?.admission_preference_status === 2){
        setIsSubmitted(true) 
        setTimeout(()=>{
          window.location.search?.includes('destination=http') ? window.location.href = destination : window.location.href = 'https://www.careers360.com';
        },5000)
      }
      if(props?.idpData?.idp_form_id && ![-1].includes(props?.idpData?.idp_form_id)){
        window.location.search?.includes('destination=http') ? window.location.href = destination : window.location.href = 'https://www.careers360.com';
      }
      return () => {
        props.dispatch(clearSchoolIdpResponse());
      };
    },[props.idpData, formikState])

    const isValidate = (data)=> {
      let item
      let validateData = Object.values(data)
      if(validateData?.length <=2) return true
      for(item of validateData) {
        if (!Array.isArray(item)) {
          if(item === '') return true
        }
        if (item.length === 0) return true;
      }
      return false;
    }

    useEffect(()=>{
      setIsDisable(isValidate(formikVal))
    },[formikVal])

    const validate= values => {
      let errors = {}
      return errors
    }   

    const posthandle = (key, bool, value)=>{
      let source_url = window.location.href
      const postData ={
        uid:props.user?.data?.id,
        idp_type:"school_idp",
        idp_form_id:-1,
        exam:[],
        unselected_exam:[],
        coaching_interested:"",
        coaching:[],
        unselected_coaching:[],
        private_college:[],
        unselected_private_college:[],
        scholarship:[],
        unselected_scholarship:[],
        premimum_guidence:[],
        unselected_premimum_guidence:[],
        c360_counsellor_interested:"",
        field_of_study:[],
        unselected_field_of_study:[],
        field_of_study_interested:'',
        study_abroad_interested:"",
        courses:[],
        unselected_courses:[],
        careers:[],
        unselected_careers:[],
        admission_prefference_status:'',
        source_url: source_url
      }
      if(['exam','coaching','private_college','scholarship','premimum_guidence','courses','field_of_study','careers','coaching_location'].includes(key)){
        if(bool) {
          props.dispatch(postSchoolIdp({
            ...postData,
            [key]: [value]
          }));
        } else {
          let unselect = 'unselected_'+key
          props.dispatch(postSchoolIdp({
            ...postData,
            [unselect]: [value]
          }));
        }
      } else {
        props.dispatch(postSchoolIdp({
          ...postData,
          [key]: +value
        }));
      } 
    }

    const handleMultiSelectDefaultCheck = (arr) => {
      let ar = [];
      let item
      for(item of arr){
        if (item.selected) ar.push(item);
      }
      return ar;
    };

    const onSubmit = values => {
      if(isDisable === false){
        posthandle('admission_prefference_status', true, 2)
        props.dispatch(getSchoolFormData({uid: props.user?.data?.id, ms:randomNum()}));
        setSubmitLoader(true) 
      }
   }

    useEffect(() => {
      const gotToHomePage = window.location?.origin;
      if (props?.isUser?.user_error === "User Not Authenticated" && !!destination)
        window.location.href = destination;
      else if (props?.isUser?.user_error === "User Not Authenticated" && !destination)
        window.location.href = gotToHomePage;
      else if (!!props?.isUser?.user && !destination)
        window.location.href = gotToHomePage;
    }, [props?.isUser, destination]);
    
    const handleCount = ()=>{
      setCount({num:fieldOfStudyData?.value?.length,show:false})
    }

    return (<>
      {isSubmitted && <ThankYou destinationUrl={destination} thankYouImg={'thankyou-school.png'}/>}
      {isLoading ? <Loader/> :
      
      <Formik initialValues={formikState} enableReinitialize={true} onSubmit={onSubmit}  validate={validate} >
        {({values, setFieldValue}) => {
          setTimeout(()=>{
            setFormikVal(values)
          },10)

          let arr = []
          const handleChange=(e) =>{
            if(['exam','field_of_study','field_of_study_interested', 'courses','careers','coaching_mode','coaching_location'].includes(e.target.name)){
              // setIsLoading(true)
            }
            setCheckEntity(e.target.name)
            posthandle(e.target.name, e.target.checked, e.target.value)  
          }

          const handleMultiSelect = (obj, actionMeta) => {
            let isCheck = actionMeta.action === 'select-option' ? true : false
            let getID = actionMeta.action === 'select-option' ? actionMeta.option.id : actionMeta.removedValue.id
            
            if(['exam','field_of_study','field_of_study_interested', 'courses','careers','coaching_location'].includes(actionMeta.name)){
              // setIsLoading(true)
            }
            setCheckEntity(actionMeta.name)
            posthandle(actionMeta.name, isCheck, getID)

            let objID = actionMeta?.action === 'select-option' ? actionMeta?.option?.id : actionMeta?.removedValue?.id
            let tempArr = [...values[actionMeta.name]]
            let oldIDs = []
            if(isCheck){
              oldIDs = [...values[actionMeta.name],`${objID}`]
            } else {
              let index = values[actionMeta.name].indexOf(`${actionMeta.removedValue.id}`);
              tempArr?.splice(index,1);
              oldIDs = tempArr
            }
            setFieldValue(actionMeta.name, oldIDs);
          };

          return (
            <Form>
                {/* { !!studyInterestedData?.value?.length && 
                    <div className="idp_medical_card">
                      <Controler control="radio" handleChange={handleChange} isMandatory={true} options={studyInterestedData?.value} name="field_of_study_interested" questionName="Field of study interested?" />
                      <div className="idp_info_strip">
                          <img src={require("../../assets/images/info.png")} alt="" />
                          Simply dummy text of the printing and typesetting
                      </div>
                    </div>
                } */}

                { !!fieldOfStudyData?.value?.length && 
                    <div className="idp_medical_card radio_with_button field_study">
                      <Controler control="radio" handleChange={handleChange} isMandatory={true} options={fieldOfStudyData?.value.slice(0,count?.num)} name="field_of_study" questionName="Which field of study would you be interested in?" />
                      {count.show && <span className="more_count" onClick={handleCount}>+{fieldOfStudyData?.value?.length - count?.num} More</span>}
                    </div>
                }
  
                { !!careersData?.value?.length && 
                    <div className="idp_medical_card">
                      <Controler control="checkbox" handleChange={handleChange} isMandatory={true} formikValues={formikVal['careers']} options={careersData?.value?.slice(0,5)} name="careers" questionName="Do you have any career aspirations in mind?" />
                      {careersData?.value?.length >= 6 &&
                        <Controler control="react_select" handleChange={handleMultiSelect} hendleDefaultCheck={handleMultiSelectDefaultCheck} formikValues={formikVal} options={careersData?.value?.slice(5)} name="careers" questionName="" />
                      }
                      
                      {!!values['careers']?.length &&
                        <div id={`msg_success_${`careers`}`} className="msg_success">
                          {!values['careers']?.includes('0') ?
                            'We’ll send you the career guides for the careers selected by you.'
                            :
                            "We'll send you a psychometric test that will help you decide your dream career"
                          }
                        </div>
                      }
                    </div>
                }
  
                { !!coursesData?.value?.length && 
                    <div className="idp_medical_card">
                      <Controler control="checkbox" handleChange={handleChange} isMandatory={true} options={coursesData?.value?.slice(0,5)} formikValues={formikVal['courses']} name="courses" questionName={`Following are the top courses in ${interestedField || ''}. Select the course you might be interested in.`} />
                      {coursesData?.value?.length >= 6 &&
                        <Controler control="react_select" handleChange={handleMultiSelect} hendleDefaultCheck={handleMultiSelectDefaultCheck} options={coursesData?.value?.slice(5)} name="courses" questionName="" />
                      }
                      
                      <div className="idp_info_strip">
                          <img src={require("../../assets/images/info.png")} alt="" />
                          The choice of course depends on the career that you want to pursue. 
                      </div>
                    </div>
                }
  
                { !!examsData?.value?.length && 
                    <div className="idp_medical_card">
                      <Controler control="checkbox" handleChange={handleChange} isMandatory={true} options={examsData?.value?.slice(0,7)} formikValues={formikVal['exam']} name="exam" 
                        questionName={`${[-1].includes(educationStream) ? 'You can give the following exams to pursue these courses.':'Which exams are you targeting?'}`}
                      />

                      {examsData?.value?.length >= 8 &&
                        <Controler control="react_select" handleChange={handleMultiSelect} hendleDefaultCheck={handleMultiSelectDefaultCheck} options={examsData?.value?.slice(7)} name="exam" questionName="" />
                      }
                      
                      {![-1].includes(educationStream) &&
                        <div className="idp_info_strip">
                          <img src={require("../../assets/images/info.png")} alt="" />
                          The choice of exam depends on the degree and specialization you seek to pursue.
                      </div>
                      }
                    </div>
                }

                {!!coachingMode?.value?.length && 
                  <div className="idp_medical_card">
                    <Controler control="radio" handleChange={handleChange} isMandatory={true} options={coachingMode?.value} name="coaching_mode" questionName="Are you interested in coaching? Which mode would you prefer?" />
                    <div className="idp_info_strip">
                        <img src={require("../../assets/images/info.png")} alt="" />
                        We will guide you to coaching institutions that may be beneficial for you.
                    </div>
                  </div>
                }

                {!!coachingLocation?.value?.length &&
                  <div className="idp_medical_card">
                    <Controler control="checkbox" handleChange={handleChange} isMandatory={true} options={coachingLocation?.value?.slice(0,8)} formikValues={formikVal['coaching_location']} name="coaching_location" 
                      questionName="Please select your preferred location for coaching"
                    />

                    {coachingLocation?.value?.length >= 9 &&
                      <Controler control="react_select" handleChange={handleMultiSelect} hendleDefaultCheck={handleMultiSelectDefaultCheck} options={coachingLocation?.value?.slice(8)} name="coaching_location" questionName="" />
                    }
                  </div>
                }
  
                { !!coachingInterestedData?.value?.length && 
                    <div className="idp_medical_card">
                      <Controler control="radio" handleChange={handleChange} isMandatory={true} options={coachingInterestedData?.value} name="coaching_interested" questionName="Are you interested in coaching?" />
                      <div className="idp_info_strip">
                          <img src={require("../../assets/images/info.png")} alt="" />
                          We will guide you to coaching institutions that may be beneficial for you.
                      </div>
                    </div>
                }
  
                { !!coachingData?.value?.length && 
                    <div className="idp_medical_card">
                      <Controler control="checkbox" handleChange={handleChange} isMandatory={true} options={coachingData?.value?.slice(0,10)} formikValues={formikVal['coaching']} name="coaching" questionName="These coaching institutions help your preparation. Select your preferred coaching." />
                      {coachingData?.value?.length >= 11 &&
                        <Controler control="react_select" handleChange={handleMultiSelect} hendleDefaultCheck={handleMultiSelectDefaultCheck} options={coachingData?.value?.slice(10)} name="coaching" questionName="" />
                      }
                      
                      <div className="idp_info_strip">
                          <img src={require("../../assets/images/info.png")} alt="" />
                          We will guide you to coaching institutions that may be beneficial for you.
                      </div>
                    </div>
                }
                
                { !!privateCollegeData?.value?.length && 
                  <div className="idp_medical_card">
                      <Controler control="checkbox" handleChange={handleChange} isMandatory={true} options={privateCollegeData?.value} formikValues={formikVal['private_college']} name="private_college" questionName="The following list has the best ranked Private colleges. Select the colleges that are of interest to you?" />
                  </div>
                }
  
                { !!scholarshipData?.value?.length && 
                  <div className="idp_medical_card">
                      <Controler control="checkbox" handleChange={handleChange} isMandatory={true} formikValues={formikVal['scholarship']} options={scholarshipData?.value?.slice(0,6)} name="scholarship" questionName="Please select the scholarship exam you may be interested in." />
                      {scholarshipData?.value?.length >= 7 &&
                        <Controler control="react_select" handleChange={handleMultiSelect} hendleDefaultCheck={handleMultiSelectDefaultCheck} options={scholarshipData?.value?.slice(6)} name="scholarship" questionName="" />
                      }
                      <div className="idp_info_strip">
                          <img src={require("../../assets/images/info.png")} alt="" />
                          These scholarships can help you by providing financial assistance for your higher studies.
                      </div>
                  </div>
                }
  
                { !!studyAbroadData?.value?.length && 
                  <div className="idp_medical_card">
                      <Controler control="radio" handleChange={handleChange} isMandatory={true} options={studyAbroadData?.value} name="study_abroad_interested" questionName="Would you be interested in studying abroad?" />
                      <div className="idp_info_strip">
                          <img src={require("../../assets/images/info.png")} alt="" />
                          Get guidance from choosing the country to choosing the University for studying abroad.
                      </div>
                  </div>
                }
  
                { !!premiumGuidenceData?.value?.length && 
                  <div className="idp_medical_card">
                      <Controler control="checkbox" handleChange={handleChange} isMandatory={true} options={premiumGuidenceData?.value} formikValues={formikVal['premimum_guidence']} name="premimum_guidence" questionName="Would you want Career guidance on any of these areas?" />
                      <div className="idp_info_strip">
                          <img src={require("../../assets/images/info.png")} alt="" />
                          Get information and advice on careers, colleges, exams, etc. Engage with counselors and make informed choices.
                      </div>
                  </div>
                }
  
                { !!careersCounsellorData?.value?.length && 
                  <div className="idp_medical_card">
                      <Controler control="radio" handleChange={handleChange} isMandatory={true} options={careersCounsellorData?.value} name="c360_counsellor_interested" questionName="Would you like to hire a Careers360 Counselor to get career guidance?" />
                      <div className="idp_info_strip">
                          <img src={require("../../assets/images/info.png")} alt="" />
                          Get guidance through free counseling sessions exclusively developed by our career experts and clear all your doubts.
                      </div>
                  </div>
                }
                
                <div className="user_guide">This is a quick form designed to understand your needs and help you in your education journey and get into the right college.</div>

                <div className="idp_medicine_btn_Submit">
                  {submitLoader ? 
                    <ButtonLoader/> :
                    <input type="submit" className="action-button btn" 
                      disabled={isDisable}
                      value="Submit your preferences" 
                    />
                  }
                </div>
            </Form>
          )
        }}  
      </Formik> 

      }
    </>)
    
}
const mapStateToProps = (state) => {
    return {
    user: state.userData?.user,
    isUser: state.userData,
    idpData : state?.idpSchool?.schoolIdpSuccess?.data,
    idpPostData : state?.idpSchool?.postSchoolIdpSuccess?.data,
  };
};  

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(IdpCollegeForms);
